import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { DynamicComponent } from "app/data/dashboard/interfaces/dynamic-component.interface";
import { MyTabComponent } from "@dashboard/components/partials/my-tab/my-tab.component";
import { KlConfirmDialogOptions } from "@app/modules/shared/components/kl-confirm-dialog/kl-confirm-dialog.component";

export interface TabConfig {
  id: string;
  icon: string;
  title: string;
  changeStatus?: boolean;
  isCloseable?: boolean;
  childTemplate: DynamicComponent;
}

export interface ModalConfig {
  title: string;
  stateSelector: string;
  childTemplate?: DynamicComponent;
}

export interface TransferState {
  state: string;
  payload: any;
}

export interface ContextMenu {
  event: MouseEvent;
  payload: Array<MenuItemInterface>;
}

export interface MenuItemInterface {
  label: string;
  method: Function;
}

@Injectable()
export class ExplorerService {
  private formChangeStatus = new Subject<any>();
  private tabStream = new Subject<TabConfig>();
  private closeEvent = new Subject<MyTabComponent>();
  private closeAllTabEvent = new Subject<boolean>();
  private modalStream = new Subject<any>();
  private messagePanelStream = new Subject<any>();
  private modalCloseStream = new Subject<any>();
  private messagePanelCloseStream = new Subject<any>();
  private transferStateResource = new Subject<TransferState>();
  private endProssessRefresh = new Subject<string>();
  private doRefresh = new Subject<boolean>();
  private userStream: BehaviorSubject<any> = new BehaviorSubject(null);
  private userRolesStream = new BehaviorSubject(null);
  private menuCollapseStream = new BehaviorSubject(null);
  private contextMenu = new Subject<ContextMenu>();
  private widgetSettings = new Subject<any>();
  private changeDashboard = new Subject<any>();
  private changeLanguage = new Subject<string>();
  private klConfirmDialogStream = new Subject<KlConfirmDialogOptions>();

  tabStream$ = this.tabStream.asObservable();
  formChangeStatus$ = this.formChangeStatus.asObservable();
  closeEvent$ = this.closeEvent.asObservable();
  closeAllTabEvent$ = this.closeAllTabEvent.asObservable();
  modalStream$ = this.modalStream.asObservable();
  modalCloseStream$ = this.modalCloseStream.asObservable();
  transferState$ = this.transferStateResource.asObservable();
  doRefresh$ = this.doRefresh.asObservable();
  userStream$ = this.userStream.asObservable();
  menuCollapseStream$ = this.menuCollapseStream.asObservable();
  public userRolesStream$ = this.userRolesStream.asObservable();
  public contextMenu$ = this.contextMenu.asObservable();
  public changeLanguage$ = this.changeLanguage.asObservable();
  endProssessRefresh$ = this.endProssessRefresh.asObservable();

  setUserProfile(user: any) {
    this.userStream.next(user);
  }

  menuCollapse() {
    this.menuCollapseStream.next(true);
    setTimeout(() => {
      this.menuCollapseStream.next(false);
    }, 100);
  }

  getUserProfile() {
    return this.userStream.getValue();
  }

  setUserRoles(roles: any) {
    this.userRolesStream.next(roles);
  }

  closeAllTab(event: boolean): void {
    this.closeAllTabEvent.next(event);
  }

  closeTab(tab: any): void {
    this.closeEvent.next(tab);
  }

  openTab(tabConfig: TabConfig): void {
    this.tabStream.next(tabConfig);
  }

  setLanguage(language) {
    this.changeLanguage.next(language);
  }

  openModal(modalConfig: ModalConfig): void {
    this.modalStream.next(modalConfig);
  }

  public closeModal(modalConfig: any): void {
    this.modalCloseStream.next(modalConfig);
  }

  openMessagePanel(message: any): void {
    this.messagePanelStream.next(message);
  }

  closeMessagePanel(messagePanel: any): void {
    this.messagePanelCloseStream.next(messagePanel);
  }

  transferState(transferState: TransferState) {
    this.transferStateResource.next(transferState);
  }

  doRefreshGrid(refresh: boolean) {
    this.doRefresh.next(refresh);
  }

  changeFormStatus(event) {
    this.formChangeStatus.next({
      tabId: event.tabId,
      changeForm: event.changeForm,
    });
  }

  showContextMenu(event: ContextMenu) {
    this.contextMenu.next(event);
  }

  setWidgetSettings(settings) {
    this.widgetSettings.next(settings);
  }

  setChangeDashboard(dashboard) {
    this.changeDashboard.next(dashboard);
  }

  setRefreshEndProsseses(tabId) {
    this.endProssessRefresh.next(tabId);
  }
}
